import React, { useState, useEffect, useRef } from 'react'
import './filter-option.scss'
import { Dropdown } from 'primereact/dropdown'
import { OverlayPanel } from 'primereact/overlaypanel'
import { Slider } from 'primereact/slider'
import { InputText } from 'primereact/inputtext'
// import { Divider } from 'primereact/divider'
import { Button } from 'primereact/button'
import clockIcon from '../../assets/images/clock.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SelectButton } from 'primereact/selectbutton'
import { setSearchFormData } from '../../redux/actions/searchFormActions'
import filterIcon from '../../assets/images/filter.svg'
import closeIcon from '../../assets/images/close.png'
import {
	clearItemFromSessionStorage,
	getBase64Decoded,
	getBase64Encoded,
	getFromSessionStorage,
	setToSessionStorage,
} from '../../utils/StorageUtils'
import { useTranslation } from 'react-i18next'
import { UNKNOWN_SHIPPER_ENABLED } from '../../configs/featureControlConfig'
import {
	updateFlightSearchFilterData,
	updateFlightSearchSortingData
} from '../../utils/analytics'
import { PrimaryButton } from '../../common/Buttons'
import { Dialog } from 'primereact/dialog'
import CommonRadioWithLabel from "../../common/CommonRadioButton";

const FilterOptions = ({
	setFiltersToState,
	filters,
	searchFormData,
	airportList,
	setSearchFormData,
}) => {
	const { t, i18n } = useTranslation(['labels', 'errors'])
	const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';
	const [showFilterModal, setShowFilterModal] = useState(false);
	const [cheepest, setcheepest] = useState(true)
	const [fastest, setfastest] = useState(false)
	const [leastStops, setleastStops] = useState(false)
	const [stops, setStops] = useState(null)
	const op = useRef(null)
	const sortOverlay = useRef(null)
	const [duration, setDuration] = useState(100)
	const [departureTime, setDepartureTime] = useState([0, 1439])
	const [departureTimeInHours, setDepartureTimeInHours] = useState([
		'00:00',
		'23:59',
	])
	const [arrivalTime, setArrivalTime] = useState([0, 1439])
	const [arraivalTimeInHours, setArraivalTimeInHours] = useState([
		'00:00',
		'23:59',
	])
	const [LATTime, setLATTime] = useState([0, 1439])
	const [LATTimeInHours, setLATTimeTimeInHours] = useState([
		'00:00',
		'23:59',
	])
	const [EDTTime, setEDTTime] = useState([0, 1439])
	const [EDTTimeInHours, setEDTTimeTimeInHours] = useState([
		'00:00',
		'23:59',
	])
	const [isAllotmentsOnly, setAllotmentsOnly] = useState(false)

	const [isUSBound, setIsUSBound] = useState(false)

	const [isUnknownShipment, setIsUnknownShipment] = useState(false)

	const [showPopup ,setShowPopup] = useState(false);

	const [tempCheepest, setTempCheepest] = useState(cheepest);
	const [tempFastest, setTempFastest] = useState(fastest);
	const [tempLeastStops, setTempLeastStops] = useState(leastStops);
	const [showFilterDialog, setShowFilterDialog] = useState(false);

	const initialStateAircraftClass = {
		narrowBody: true,
		wideBody: true,
		truck: true,
		freighter: true,
	}
	const [aircraftClassification, setAircraftClassification] = useState(
		initialStateAircraftClass
	)

	useEffect(() => {
		const { isUnknownShipment, isUSBound } = searchFormData
		setIsUSBound(isUSBound)
	}, [searchFormData])

	const stopsList = [
		{ label: 'Non stop', value: '0' },
		{ label: '1 Stop', value: '1' },
		{ label: '2+ Stops', value: '2+' },
	]
	const [filterUsedIs,setFilterUsedIs]=useState(false)
	useEffect(() => {
		setFiltersToState({
			...filters,
			cheepest,
			fastest,
			leastStops,
		})
	}, [cheepest, fastest, leastStops])
	useEffect(() => {
		const stopsValue = stops || stops == 0 ? parseInt(stops) : null
		setDuration(0)
		setDepartureTime([0, 1439])
		setDepartureTimeInHours(['00:00', '23:59'])
		setArrivalTime([0, 1439])
		setArraivalTimeInHours(['00:00', '23:59'])
		setLATTime([0, 1439])
		setLATTimeTimeInHours(['00:00', '23:59'])
		setEDTTime([0, 1439])
		setEDTTimeTimeInHours(['00:00', '23:59'])
		setStops(null)
		setAircraftClassification(initialStateAircraftClass)
		setFiltersToState({
			...filters,
			duration,
			departureTime,
			arrivalTime,
			departureTimeInHours,
			arraivalTimeInHours,
			LATTime,
			LATTimeInHours,
			EDTTime,
			EDTTimeInHours,
			stop: stopsValue,
			isUnknownShipment: searchFormData ? searchFormData.isUnknownShipment : null,
			aircraftClassification,
		})
		/* const dummy = {
			duration: 0,
			aircraftClassification: '',
			stops: null,
		}
		setToSessionStorage('selectedfilter', getBase64Encoded(dummy)) */
		return () => {
			const encodedFormData = getFromSessionStorage('searchObject')
			const formData = getBase64Decoded(encodedFormData)
			setSearchFormData(formData)
		}
	}, [])

	const showFilter = (e) => {
		// op.current.toggle(e)
		setShowFilterDialog(true);
		setDepartureTime(filters.departureTime)
		setArrivalTime(filters.arrivalTime)
		setDuration(filters.duration)
		setArraivalTimeInHours(filters.arraivalTimeInHours)
		setDepartureTimeInHours(filters.departureTimeInHours)
		setLATTime(filters.LATTime)
		setLATTimeTimeInHours(filters.LATTimeInHours)
		setEDTTime(filters.EDTTime)
		setEDTTimeTimeInHours(filters.EDTTimeInHours)
		// setStops(
		// 	filters.stops ? toString(filters.stops) : filters.stops == 0 ? '0' : null
		// )
		setStops(
		filters.stops !== undefined && filters.stops !== null
		? filters.stops.toString()
		: null
		)
		setAircraftClassification(filters.aircraftClassification)
	}

	const stopTemplate = (option) => {
		if (!option.value) {
			return option.label
		} else {
			return (
				<div>
					<span>{option.value}</span>
				</div>
			)
		}
	}
	useEffect(() => {
		if (!filters) {
			var sort = 'cheapest'
			setToSessionStorage('sortOption', sort)
		}
	},
		[filters])
	const setFilter = (filter) => {
		if (filter == 'cheepest') {
			setcheepest(true)
			setfastest(false)
			setleastStops(false)
		}
		if (filter == 'leastStops') {
			setcheepest(false)
			setfastest(false)
			setleastStops(true)
		}
		if (filter == 'fastest') {
			setcheepest(false)
			setfastest(true)
			setleastStops(false)
		}
		let sortOption = filter
		if (filter === 'cheepest') {
			sortOption = 'cheapest'
		}
		clearItemFromSessionStorage('sortOption')
		setToSessionStorage('sortOption', sortOption)
		updateFlightSearchSortingData(sortOption)
	}

	const covertDecimalToTime = (component, value) => {
		let startTime, endTime

		const formatTimeLabel = (hour, minute) =>
			`${hour.toString().padStart(2, '0')}:${minute}`

		value.forEach((element, index) => {
			let hoursAndMinute = element / 60
			let hour = parseInt(hoursAndMinute)
			let minute = hoursAndMinute % 1
			minute = parseInt(minute * 60)
				.toString()
				.padStart(2, 0)
			if (index === 0) {
				startTime = formatTimeLabel(hour, minute)
			} else {
				endTime = formatTimeLabel(hour, minute)
			}
		})
		if (component === 'departure') {
			setDepartureTimeInHours([startTime, endTime])
			setDepartureTime(value)
		} else if (component === 'arraival') {
			setArraivalTimeInHours([startTime, endTime])
			setArrivalTime(value)
		} else if (component == 'LAT') {
			setLATTimeTimeInHours([startTime, endTime])
			setLATTime(value)
		} else {
			setEDTTimeTimeInHours([startTime, endTime])
			setEDTTime(value)
		}
	}

	const onFilter = (e) => {
		const stopsValue =
		stops !== null && stops !== undefined
		? (stops === '2+' ? '2+' : parseInt(stops))
		: null
		// const stopsValue =
		// 	stops || stops == 0 ? (stops !== '2+' ? parseInt(stops) : stops) : null
		setShowFilterDialog(false);
		if (showFilterModal) {
			setShowFilterModal(!showFilterModal)
		}
		setFiltersToState({
			...filters,
			duration,
			departureTime,
			arrivalTime,
			departureTimeInHours,
			arraivalTimeInHours,
			LATTime,
			LATTimeInHours,
			EDTTime,
			EDTTimeInHours,
			stops: stopsValue,
			isAllotmentsOnly,
			aircraftClassification,
		})
		 setFilterUsedIs(true)
	}
	if(filterUsedIs==true){
		const selectedfilter = {
		   duration: duration,
		   aircraftClassification: aircraftClassification,
		   stops: stops,
	   }
	   setToSessionStorage('selectedfilter', getBase64Encoded(selectedfilter)) 
	   updateFlightSearchFilterData(selectedfilter)
   }
   else{
	const dummy = {
		duration: 0,
		aircraftClassification: '',
		stops: null,
	}
	setToSessionStorage('selectedfilter', getBase64Encoded(dummy))
   } 
	const onClear = (e) => {
		setDuration(100)
		setDepartureTime([0, 1439])
		setDepartureTimeInHours(['00:00', '23:59'])
		setArrivalTime([0, 1439])
		setArraivalTimeInHours(['00:00', '23:59'])
		setLATTime([0, 1439])
		setLATTimeTimeInHours(['00:00', '23:59'])
		setEDTTime([0, 1439])
		setEDTTimeTimeInHours(['00:00', '23:59'])
		setStops(null)
		setAircraftClassification({
			narrowBody: true,
			wideBody: true,
			truck: true,
			freighter: true,
		})
	}

	const handleUnknownShimentFilter = (isUnknownShipment) => {
		let tempFilters = filters ?
			{
				...filters,
				isUnknownShipment,
			} :
			{
				isUnknownShipment
			}
		setFiltersToState(tempFilters)
		setIsUnknownShipment(isUnknownShipment)
		searchFormData.isUnknownShipment = isUnknownShipment
		const tempFormData = {
			...searchFormData,
			isUnknownShipment,
		}
		setToSessionStorage('searchObject', getBase64Encoded(tempFormData))
	}

	useEffect(() => {
		if (filters) {
			const { isUnknownShipment } = filters
			setIsUnknownShipment(isUnknownShipment)

			const tempFormData = {
				...searchFormData,
				isUnknownShipment,
			}
			setToSessionStorage('searchObject', getBase64Encoded(tempFormData))
		}

	}, [filters])

	const handleAllotmentFilter = (isAllotmentsOnly, e) => {
		const stopsValue =
			stops || stops == 0 ? (stops !== '2+' ? parseInt(stops) : stops) : null
		setFiltersToState({
			...filters,
			duration,
			departureTime,
			arrivalTime,
			departureTimeInHours,
			arraivalTimeInHours,
			LATTime,
			LATTimeInHours,
			EDTTime,
			EDTTimeInHours,
			stops: stopsValue,
			isAllotmentsOnly,
			aircraftClassification,
		})
	}

	const handleRadio = (e) => {
		setStops(e.target.value)
	}

	useEffect(() => {
		if (UNKNOWN_SHIPPER_ENABLED &&
			airportList && airportList.length) {
			const isUSBound = airportList.some(flight => flight.usoutbound)
			if (isUSBound) {
				setIsUSBound(isUSBound)
			}
		}
	}, [airportList])

	return (
		<div>
			
			<div className='fd-header'>
				<div className='flights_count'>
					<span className='fd-header__results'>{`${airportList && airportList.length ? airportList.length : 0
						}`}</span>
					&nbsp;
					<span className='fd-header__results'>{t('CHOOSE_FLT.NO_OF_FLTS')}</span>
				</div>
				<div className='filter_wrap'
				>
					<ul>
						
						{/* <li className='filter__item'>
					<span
						className='showFilter sort-panel'
						onClick={(e) => sortOverlay.current.toggle(e)}
					>
						{cheepest === true && 'Cheapest'}
						{fastest === true && 'Fastest'}
						{leastStops === true && 'Least stops'}
					</span>
					{cheepest ? <span className='sort-by'>Cheapest</span> : <> </>}
					{fastest ? <span className='sort-by'>Fastest</span> : <> </>}
					{leastStops ? <span className='sort-by'>Least stops</span> : <> </>}
					<OverlayPanel
						ref={sortOverlay}
						className='sort-overlay-panel'
						appendTo={document.body}
					>
						<ul>
							<li
								className={`${cheepest ? 'filter__active' : ''}`}
								onClick={(e) => {
									setFilter('cheepest')
									sortOverlay.current.hide(e)
								}}
							>
								Cheapest
							</li>
							<li
								className={`${fastest ? 'filter__active' : ''}`}
								onClick={(e) => {
									setFilter('fastest')
									sortOverlay.current.hide(e)
								}}
							>
								Fastest
							</li>
							<li
								className={`${leastStops ? 'filter__active' : ''}`}
								onClick={(e) => {
									setFilter('leastStops')
									sortOverlay.current.hide(e)
								}}
							>
								Least stops
							</li>
						</ul>
					</OverlayPanel>
				</li> */}

						<li className='filter__item-choose-flight'>
							<span className='showFilter d-none d-lg-block custom-button' onClick={(e) => showFilter(e)}>
								<span>{t('COMMON.FILTER')}</span>
								<span className='showFilter sort-panel'></span>
							</span>
							
							<span className='showFilter d-block d-lg-none custom-button' onClick={() => setShowFilterModal(!showFilterModal)}>
								<span>{t('COMMON.FILTER')}</span>
								<span className='showFilter sort-panel'></span>
							</span>

							<div className='b-none d-lg-block'>
								<Dialog
									header={null}
									visible={showFilterDialog}
									onHide={() => setShowFilterDialog(false)}
									className={`custom_overlay_panel ${isRTL ? 'rtl' : ''}`}
									closable={false}
									modal={false}
									style={{ width: '1005px', maxWidth: '95vw' }}
									contentClassName="custom_overlay_panel_content"
									footer={
										<div className='portal-row footer-buttons-row'>
											<div className='buttons-div'>
												<div>
													<button className='primary-button apply-btn'
														onClick={(e) => onFilter(e)}
													>
														{t('COMMON.APPLY')}
													</button>
													{/* <PrimaryButton
														label={t('COMMON.APPLY')}
														onClick={(e) => onFilter(e)}
													/> */}
												</div>
												<div className='mr-3'>
													<span className='resetFilter' onClick={(e) => onClear(e)}>
														{t('COMMON.RESET')}
													</span>
												</div>
											</div>
										</div>
									}
								>

									<div>
										<span className='clearFilter filter-dialog-close'>
											<img src={closeIcon} alt='Close' title='Close' onClick={() => setShowFilterDialog(false)} />
										</span>
										<div class='portal-row'>
											<div className='all-filters'>
												<div class='col-6 border-rghtDiv'>
													<div className='filter-title-item-wrapper'>
														<span className='filter-title'>{t('CHOOSE_FLT.DEP_TIME')}</span>

														<div class='row align-items-center'>
															<div class='col-3'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={departureTimeInHours[0]} />
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
															<div className='col-6'>
																<Slider
																	value={departureTime}
																	onChange={(e) =>
																		covertDecimalToTime('departure', e.value)
																	}
																	range
																	min={0}
																	max={1439}
																	className='custom-slider'
																/>
															</div>
															<div class='col-3'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={departureTimeInHours[1]} />
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
														</div>
													</div>
													<div className='filter-title-item-wrapper'>
														<div className='cusom_returntime filter-title'>{t('CHOOSE_FLT.ARR_TIME')}</div>

														<div class='row align-items-center'>
															<div class='col-3'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={arraivalTimeInHours[0]} />
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
															<div className='col-6'>
																<Slider
																	value={arrivalTime}
																	onChange={(e) => covertDecimalToTime('arraival', e.value)}
																	range
																	min={0}
																	max={1439}
																	className='custom-slider'
																/>
															</div>
															<div class='col-3'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={arraivalTimeInHours[1]} />
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
														</div>
													</div>
													<div className='duration-section'>
														<div className='silder-div'>
															<div className='cusom_returntime filter-title duration-title'>{t('CHOOSE_FLT.DURATION')} {t('CHOOSE_FLT.UNDER')}</div>

															<Slider
																value={duration}
																onChange={(e) => setDuration(e.value)}
																className='custom-slider duration-slider'
															/>
														</div>
														<div className='duration-div'>
															{/* <span className='under-text'>{t('CHOOSE_FLT.UNDER')}</span> */}
															<div className='custom_input_group duration-input'>
																{/* <div className='p-inputgroup'>
																	<InputText
																		value={duration}
																		onChange={(e) => setDuration(e.target.value)}
																	/>
																	<span className='p-inputgroup-addon'>{t('COMMON.HRS')}</span>
																</div> */}

																<span className='p-inputgroup time-panel'>
																	<InputText className='hours-box' value={duration} />
																	<span className='p-inputgroup-addon'>{t('COMMON.HRS')}</span>
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
														</div>
													</div>
													<span className='cusom_label filter-title'>{t('CHOOSE_FLT.NO_OF_STOPS')}</span>
													<div className='cargo-portal-container form-row stops-radio-wrapper mt-3'>
														<div className='col-4 col-md-auto'>
															<CommonRadioWithLabel
															onChange={handleRadio}
																	checked={stops === '0' ? true : false}
															value='0'
															className={`radio-toggle-first`}
															label={t('CHOOSE_FLT.NON_STOP')}
															name='numberOfStops'
														/>
															
															{/* <div className='form-item form-item--radio'>
																<input
																	id='nonStop'
																	type='radio'
																	value='0'
																	name='numberOfStops'
																	className='form-item__field'
																	aria-describedby='nonStop'
																	onChange={handleRadio}
																	checked={stops === '0' ? true : false}
																/>
																<label htmlFor='nonStop' className='form-item__label form-item__radio_label'>
																	{t('CHOOSE_FLT.NON_STOP')}
																</label>
															</div> */}
														</div>
														<div className='col-4 col-md-auto'>
															<CommonRadioWithLabel
															onChange={handleRadio}
															checked={stops === '1' ? true : false}
															value='1'
															className={`radio-toggle-first`}
															label={`1 ${t('COMMON.STOP')}`}
															name='numberOfStops'
														/>
															{/* <div className='form-item form-item--radio'>
																<input
																	id='oneStop'
																	type='radio'
																	value='1'
																	name='numberOfStops'
																	className='form-item__field'
																	aria-describedby='oneStop'
																	onChange={handleRadio}
																	checked={stops === '1' ? true : false}
																/>
																<label htmlFor='oneStop' className='form-item__label form-item__radio_label'>
																	1 {t('COMMON.STOP')}
																</label>
															</div> */}
														</div>
														<div className='col-4 col-md-auto'>
															<CommonRadioWithLabel
															aria-describedby='moreStops'
																	onChange={handleRadio}
																	checked={stops === '2+' ? true : false}
															value='2+'
															className={`radio-toggle-first`}
															label={`2+ ${t('CHOOSE_FLT.STOPS')}`}
															name='numberOfStops'
														/>
															{/* <div className='form-item form-item--radio'>
																<input
																	id='moreStops'
																	type='radio'
																	value='2+'
																	name='numberOfStops'
																	className='form-item__field'
																	aria-describedby='moreStops'
																	onChange={handleRadio}
																	checked={stops === '2+' ? true : false}
																/>
																<label
																	htmlFor='moreStops'
																	className='form-item__label form-item__radio_label'
																>
																	2+ {t('CHOOSE_FLT.STOPS')}
																</label>
															</div> */}
														</div>
													</div>

													{/* <div className='allotment-filter-section'>
													<span className='cusom_label'>Flights with allotments only</span>
													<div className='l-checkbox'>
														<input
															id={`allotment`}
															type='checkbox'
															checked={isAllotmentsOnly}
															onChange={(e) => { setAllotmentsOnly(!isAllotmentsOnly) }}
														/>
														<label className='mb-0' htmlFor={`allotment`}></label>
													</div>
												</div> */}
												</div>
												<div class='col-6' style={{ marginTop: '10px', paddingLeft: '32px' }}>
													{/* <span className='clearFilter' >
														<img src={closeIcon} alt='Close' title='Close' onClick={(e) => setShowFilterDialog(false)} />
													</span> */}
													<div className='filter-title-item-wrapper'>
														<span className='filter-title'>{t('CHOOSE_FLT.LAT_FILTER')}</span>

														<div class='row align-items-center'>
															<div class='col-3'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={LATTimeInHours[0]} />
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
															<div className='col-6'>
																<Slider
																	value={LATTime}
																	onChange={(e) => covertDecimalToTime('LAT', e.value)}
																	range
																	min={0}
																	max={1439}
																	className='custom-slider'
																/>
															</div>
															<div class='col-3'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={LATTimeInHours[1]} />
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
														</div>
													</div>

													<div className='filter-title-item-wrapper'>
														<div className='cusom_returntime filter-title'>{t('CHOOSE_FLT.TOA_FILTER')}</div>


														<div class='row align-items-center'>
															<div class='col-3'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={EDTTimeInHours[0]} />
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
															<div className='col-6'>
																<Slider
																	value={EDTTime}
																	onChange={(e) => covertDecimalToTime('EDT', e.value)}
																	range
																	min={0}
																	max={1439}
																	className='custom-slider'
																/>
															</div>
															<div class='col-3'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={EDTTimeInHours[1]} />
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
														</div>
													</div>


													{/* <div className='custom_dropdown'>
													<SelectButton
														className='select-button shipping-type'
														value={stops}
														options={stopsList}
														onChange={(e) => {
															if (e.value) {
																setStops(e.target.value)
															}
														}}
													></SelectButton>
												</div> */}

													<span className='cusom_label filter-title'>{t('ROUTING_ENQUIRY.AIRCRAFT_CLASS')}</span>
													<div className='cargo-portal-container portal-row stops-radio-wrapper mt-3'>
														<div className='col-12 col-md-auto pr-2 mb-2'>
															<div
																className=' l-checkbox'
															>
																<input
																	id='narrowBody'
																	checked={aircraftClassification.narrowBody}
																	value='Narrow Body'
																	type='checkbox'
																	name='narrowBody'
																	// className='form-item__field'
																	onChange={(event) => {
																		console.log("e", event)
																		setAircraftClassification({
																			...aircraftClassification,
																			narrowBody: event.target.checked
																		})
																	}}
																/>
																<label htmlFor='narrowBody' className='form-item__label'>
																	{t('COMMON.NB')}
																</label>
															</div>
														</div>
														<div className='col-12 col-md-auto pr-2 mb-2'>
															<div
																className='l-checkbox'
															>
																<input
																	id='wideBody'
																	checked={aircraftClassification.wideBody}
																	value='Wide Body'
																	type='checkbox'
																	name='wideBody'
																	// className='form-item__field'
																	onChange={(event) => {
																		setAircraftClassification({
																			...aircraftClassification,
																			wideBody: event.target.checked
																		})
																	}}
																/>
																<label htmlFor='wideBody' className='form-item__label'>
																	{t('COMMON.WB')}
																</label>
															</div>
														</div>
														<div className='col-12 col-md-auto pr-3 mb-2'>
															<div
																className='l-checkbox'
															>
																<input
																	id='truck'
																	checked={aircraftClassification.truck}
																	value='Truck'
																	type='checkbox'
																	name='truck'
																	// className='form-item__field'
																	onChange={(event) => {
																		setAircraftClassification({
																			...aircraftClassification,
																			truck: event.target.checked
																		})
																	}}
																/>
																<label htmlFor='truck' className='form-item__label'>
																	{t('ROUTING_ENQUIRY.TRUCK')}
																</label>
															</div>
														</div>
														<div className='col-12 col-md-auto pr-3 mb-2'>
															<div
																className='l-checkbox'
															>
																<input
																	id='freighter'
																	checked={aircraftClassification.freighter}
																	value='Freighter'
																	type='checkbox'
																	name='freighter'
																	// className='form-item__field'
																	onChange={(event) => {
																		setAircraftClassification({
																			...aircraftClassification,
																			freighter: event.target.checked
																		})
																	}}
																/>
																<label htmlFor='freighter' className='form-item__label'>
																	{t('ROUTING_ENQUIRY.FREIGHTER_FLIGHT')}
																</label>
															</div>
														</div>
													</div>

													<span className='cusom_label filter-title'>{t('DASHBOARD.ALLMNT')}</span>
													<div className='cargo-portal-container form-row allotment-radio-wrapper mt-3'>
														<div className='col-6 col-md-auto'>
															<CommonRadioWithLabel
																aria-describedby='allAllotments'
																	onChange={(e) => setAllotmentsOnly(false)}
																	checked={!isAllotmentsOnly} // Default to "All"
																value='all'
																className={`radio-toggle-first`}
																label={t('COMMON.ALL')}
																name='allotmentFilter'
															/>
															{/* <div className='form-item form-item--radio'>
																<input
																	id='allAllotments'
																	type='radio'
																	value='all'
																	name='allotmentFilter'
																	className='form-item__field'
																	aria-describedby='allAllotments'
																	onChange={(e) => setAllotmentsOnly(false)}
																	checked={!isAllotmentsOnly} 
																/>
																<label htmlFor='allAllotments' className='form-item__label form-item__radio_label'>
																	{t('COMMON.ALL')}

																</label>
															</div> */}
														</div>
														<div className='col-6 col-md-auto'>
															<CommonRadioWithLabel
																aria-describedby='onlyWithAllotments'
																	onChange={(e) => setAllotmentsOnly(true)} // Set to "Only with Allotment"
																	checked={isAllotmentsOnly} // Selected when "Only with Allotment" is chosen
																value='onlyWithAllotments'
																	name='allotmentFilter'
																className={`radio-toggle-first`}
																label={t('COMMON.ONLY_ALLMNT')}
																
															/>
															{/* <div className='form-item form-item--radio'>
																<input
																	id='onlyWithAllotments'
																	type='radio'
																	value='onlyWithAllotments'
																	name='allotmentFilter'
																	className='form-item__field'
																	aria-describedby='onlyWithAllotments'
																	onChange={(e) => setAllotmentsOnly(true)} 
																	checked={isAllotmentsOnly} 
																/>
																<label htmlFor='onlyWithAllotments' className='form-item__label form-item__radio_label'>
																	{t('COMMON.ONLY_ALLMNT')}

																</label>
															</div> */}
														</div>
													</div>


												</div>
											</div>
										</div>

									</div>

								</Dialog>
							</div>
				
							{showFilterModal ?
								<div className='showFilter_Mob'>
									
									<div>
										<div className='all-filters'>
											<span className='showFilter_Mob-close' onClick={() => setShowFilterModal(!showFilterModal)}>
											<img src={closeIcon} alt="close" />
										   </span>
											<div class='portal-col border-rghtDiv'>
												<div className=''>
                                                   <div className='filter-title-item-wrapper'>
													<span className='filter-title d-flex'>{t('CHOOSE_FLT.DEP_TIME')}</span>
													
													<div className='filterField_wrap'>
														<div className='filterField_row'>
															<div className='filterField col-5'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={departureTimeInHours[0]} />
																</span>
															</div>
															<div className='filterField col-5'>
																<Slider
																	value={departureTime}
																	onChange={(e) => covertDecimalToTime('departure', e.value)}
																	range
																	min={0}
																	max={1439}
																	className='custom-slider'
																/>
															</div>
															<div className='filterField col-5'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={departureTimeInHours[1]} />
																</span>
															</div>
														</div>
													</div>
													</div>
												
												  <div className='filter-title-item-wrapper'>
													<div className='cusom_returntime filter-title d-flex'>{t('CHOOSE_FLT.ARR_TIME')}</div>
											
													<div class='filterField_wrap'>
														<div className='filterField_row'>
															<div class='filterField col-5'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={arraivalTimeInHours[0]} />
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
															<div className='filterField col-5'>
															<Slider
																value={arrivalTime}
																onChange={(e) => covertDecimalToTime('arraival', e.value)}
																range
																min={0}
																max={1439}
																className='custom-slider'
															/>
                                                            </div>
															<div class='filterField col-5'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={arraivalTimeInHours[1]} />
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
														</div>
													</div>
												  </div>	
													<div className='duration-section'>
														<div className='silder-div'>
															<div className='cusom_returntime filter-title d-flex'>{t('CHOOSE_FLT.DURATION')} {t('CHOOSE_FLT.UNDER')}</div>

															<Slider
																value={duration}
																onChange={(e) => setDuration(e.value)}
																className='custom-slider duration-slider'
															/>
														</div>
														<div className='duration-div'>
															{/* <span className='under-text d-flex'>{t('CHOOSE_FLT.UNDER')}</span> */}
															<div className='custom_input_group duration-input'>
																{/* <div className='p-inputgroup'>
																	<InputText
																		value={duration}
																		onChange={(e) => setDuration(e.target.value)}
																	/>
																	<span className='p-inputgroup-addon'>{t('COMMON.HRS')}</span>
																</div> */}
															     <span className='p-inputgroup time-panel'>
																	<InputText className='hours-box' value={duration} />
																	<span className='p-inputgroup-addon'>{t('COMMON.HRS')}</span>
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
														</div>
													</div>
													{/* <div className='allotment-filter-section'>
												<span className='cusom_label'>Flights with allotments only</span>
												<div className='l-checkbox'>
													<input
														id={`allotment`}
														type='checkbox'
														checked={isAllotmentsOnly}
														onChange={(e) => { setAllotmentsOnly(!isAllotmentsOnly) }}
													/>
													<label className='mb-0' htmlFor={`allotment`}></label>
												</div>
											</div> */}
												</div>
											</div>
											<div class='portal-col left-div'>
												<div className=''>
													<div className='filter-title-item-wrapper'>
													<span className='filter-title d-flex'>{t('CHOOSE_FLT.LAT_FILTER')}</span>
													<div class='filterField_wrap'>
														<div className='filterField_row'>
															<div class='filterField col-5'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={LATTimeInHours[0]} />
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
															<div className='filterField col-5'>
															<Slider
																value={LATTime}
																onChange={(e) => covertDecimalToTime('LAT', e.value)}
																range
																min={0}
																max={1439}
																className='custom-slider'
															/>
															</div>
															<div class='filterField col-5'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={LATTimeInHours[1]} />
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
														</div>
													</div>
												</div>
												<div className='filter-title-item-wrapper'>	
													<div className='cusom_returntime filter-title d-flex'>{t('CHOOSE_FLT.TOA_FILTER')}</div>
													<div class='filterField_wrap'>
														<div className='filterField_row'>
															<div class='filterField col-5'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={EDTTimeInHours[0]} />
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
															<div className='filterField col-5'>
															<Slider
																value={EDTTime}
																onChange={(e) => covertDecimalToTime('EDT', e.value)}
																range
																min={0}
																max={1439}
																className='custom-slider'
															/>
															</div>
															<div class='filterField col-5'>
																<span className='p-inputgroup time-panel'>
																	<InputText value={EDTTimeInHours[1]} />
																	{/* <span className='p-inputgroup-addon'>
																<img src={clockIcon} alt='Clock' title='Clock' />
															</span> */}
																</span>
															</div>
														</div>
													</div>
                                                  </div>
													
													<span className='cusom_label filter-title'>{t('CHOOSE_FLT.NO_OF_STOPS')}</span>
													{/* <div className='custom_dropdown'>
												<SelectButton
													className='select-button shipping-type'
													value={stops}
													options={stopsList}
													onChange={(e) => {
														if (e.value) {
															setStops(e.target.value)
														}
													}}
												></SelectButton>
											</div> */}

													<div className='cargo-portal-container form-row stops-radio-wrapper mt-2'>
														<div className='radio-row'>

															<CommonRadioWithLabel
															onChange={handleRadio}
																	checked={stops === '0' ? true : false}
															value='0'
															className={`radio-toggle-first`}
															label={t('CHOOSE_FLT.NON_STOP')}
															name='numberOfStops'
														/>
															{/* <div className='form-item form-item--radio'>
																<input
																	id='nonStop'
																	type='radio'
																	value='0'
																	name='numberOfStops'
																	className='form-item__field'
																	aria-describedby='nonStop'
																	onChange={handleRadio}
																	checked={stops === '0' ? true : false}
																/>
																<label htmlFor='nonStop' className='form-item__label'>
																	{t('CHOOSE_FLT.NON_STOP')}
																</label>
															</div> */}

															<CommonRadioWithLabel
															onChange={handleRadio}
															checked={stops === '1' ? true : false}
															value='1'
															className={`radio-toggle-first`}
															label={`1 ${t('COMMON.STOP')}`}
															name='numberOfStops'
														/>

															{/* <div className='form-item form-item--radio'>
																<input
																	id='oneStop'
																	type='radio'
																	value='1'
																	name='numberOfStops'
																	className='form-item__field'
																	aria-describedby='oneStop'
																	onChange={handleRadio}
																	checked={stops === '1' ? true : false}
																/>
																<label htmlFor='oneStop' className='form-item__label'>
																	1 {t('COMMON.STOP')}
																</label>
															</div> */}

															<CommonRadioWithLabel
															aria-describedby='moreStops'
																	onChange={handleRadio}
																	checked={stops === '2+' ? true : false}
															value='2+'
															className={`radio-toggle-first`}
															label={`2+ ${t('CHOOSE_FLT.STOPS')}`}
															name='numberOfStops'
														/>

															{/* <div className='form-item form-item--radio'>
																<input
																	id='moreStops'
																	type='radio'
																	value='2+'
																	name='numberOfStops'
																	className='form-item__field'
																	aria-describedby='moreStops'
																	onChange={handleRadio}
																	checked={stops === '2+' ? true : false}
																/>
																<label htmlFor='moreStops' className='form-item__label'>
																	2+ {t('CHOOSE_FLT.STOPS')}
																</label>
															</div> */}

														</div>
													</div>

													<span className='cusom_label filter-title'>{t('ROUTING_ENQUIRY.AIRCRAFT_CLASS')}</span>
													<div className=' cargo-portal-container form-row stops-radio-wrapper mt-2'>
														<div className='checkbox-row'>
														<div className=''>
															<div
																className=' l-checkbox'
															>
																<input
																	id='narrowBody'
																	checked={aircraftClassification.narrowBody}
																	value='Narrow Body'
																	type='checkbox'
																	name='narrowBody'
																	onChange={(event) => {
																		console.log("e", event)
																		setAircraftClassification({
																			...aircraftClassification,
																			narrowBody: event.target.checked
																		})
																	}}
																/>
																<label htmlFor='narrowBody' className='form-item__label'>
																	{t('COMMON.NB')}
																</label>
															</div>
														</div>
														<div className=''>
															<div
																className=' l-checkbox'
															>
																<input
																	id='wideBody'
																	checked={aircraftClassification.wideBody}
																	value='Wide Body'
																	type='checkbox'
																	name='wideBody'
																	onChange={(event) => {
																		setAircraftClassification({
																			...aircraftClassification,
																			wideBody: event.target.checked
																		})
																	}}
																/>
																<label htmlFor='wideBody' className='form-item__label'>
																	{t('COMMON.WB')}
																</label>
															</div>
														</div>
														<div className=''>
															<div
																className=' l-checkbox'
															>
																<input
																	id='truck'
																	checked={aircraftClassification.truck}
																	value='Truck'
																	type='checkbox'
																	name='truck'
																	onChange={(event) => {
																		setAircraftClassification({
																			...aircraftClassification,
																			truck: event.target.checked
																		})
																	}}
																/>
																<label htmlFor='truck' className='form-item__label'>
																	{t('ROUTING_ENQUIRY.TRUCK')}
																</label>
															</div>
														</div>
														</div>
														<div className='checkbox-row'>
														<div className=''>
															<div
																className=' l-checkbox'
															>
																<input
																	id='freighter'
																	checked={aircraftClassification.freighter}
																	value='Freighter'
																	type='checkbox'
																	name='freighter'
																	onChange={(event) => {
																		setAircraftClassification({
																			...aircraftClassification,
																			freighter: event.target.checked
																		})
																	}}
																/>
																<label htmlFor='freighter' className='form-item__label'>
																	{t('ROUTING_ENQUIRY.FREIGHTER_FLIGHT')}
																</label>
															</div>
														</div>
														</div>
													</div>

													<span className='cusom_label filter-title'>{t('DASHBOARD.ALLMNT')}</span>
														<div className='cargo-portal-container form-row allotment-radio-wrapper mt-2'>
															<div className='allotment-radio-row'>

															<CommonRadioWithLabel
																aria-describedby='allAllotments'
																onChange={(e) => setAllotmentsOnly(false)}
																checked={!isAllotmentsOnly} // Default to "All"
																value='all'
																className={`radio-toggle-first`}
																label={t('COMMON.ALL')}
																name='allotmentFilter'
															/>

																{/* <div className='form-item form-item--radio'>
																	<input
																		id='allAllotmentsMobile'
																		type='radio'
																		value='all'
																		name='allotmentFilterMobile'
																		className='form-item__field'
																		aria-describedby='allAllotmentsMobile'
																		onChange={(e) => setAllotmentsOnly(false)}
																		checked={!isAllotmentsOnly}
																	/>
																	<label htmlFor='allAllotmentsMobile' className='form-item__label'>
																		{t('COMMON.ALL')}
																	</label>
																</div> */}

															<CommonRadioWithLabel
																aria-describedby='onlyWithAllotments'
																onChange={(e) => setAllotmentsOnly(true)} // Set to "Only with Allotment"
																checked={isAllotmentsOnly} // Selected when "Only with Allotment" is chosen
																value='onlyWithAllotments'
																name='allotmentFilter'
																className={`radio-toggle-first`}
																label={t('COMMON.ONLY_ALLMNT')}

															/>

																{/* <div className='form-item form-item--radio'>
																	<input
																		id='onlyWithAllotmentsMobile'
																		type='radio'
																		value='onlyWithAllotments'
																		name='allotmentFilterMobile'
																		className='form-item__field'
																		aria-describedby='onlyWithAllotmentsMobile'
																		onChange={(e) => setAllotmentsOnly(true)}
																		checked={isAllotmentsOnly}
																	/>
																	<label htmlFor='onlyWithAllotmentsMobile' className='form-item__label'>
																		{t('COMMON.ONLY_ALLMNT')}
																	</label>
																</div> */}
																
															</div>
														</div>

												</div>
											</div>
											<div className='buttons-div'>
												{/* <span className='clearFilter' onClick={(e) => onClear(e)}>
													{t('COMMON.CLR')}
												</span> */}
												{/* <button
													type='button'
													className='primary-button'
													onClick={(e) => onFilter(e)}
												>
													{t('COMMON.FILTER')}
												</button> */}

												<PrimaryButton
													label={t('COMMON.APPLY')}
													onClick={(e) => onFilter(e)}
												/>
												{/* <button
													type='button'
													className='mb-0 secondary-button'
													onClick={() => setShowFilterModal(!showFilterModal)}
												>
													{t('COMMON.CANCEL')}
												</button> */}
												<span className='resetFilter' onClick={(e) => onClear(e)}>
														{t('COMMON.RESET')} 
													</span>
											</div>
										</div>
									</div>
								</div>
								: <></>}
						</li>
						<li className='filter__item-choose-flight'>
							{/* Trigger to open the popup */}
							<span
								className='showFilter sort-panel d-lg-block  custom-button'
								onClick={() => setShowPopup(true)} // Open the popup
							>
								{cheepest ? <span>{t('COMMON.CHEAPEST')}</span> : <> </>}
								{fastest ? <span>{t('CHOOSE_FLT.FASTEST')}</span> : <> </>}
								{leastStops ? <span>{t('CHOOSE_FLT.LEAST_STOPS')}</span> : <> </>}
							</span>

							{/* Popup for filter options */}
							{/* Popup for filter options */}
							{showPopup && (
								<div className='filter-popup-overlay '>
								<div className='filter-popup'>
									<div className='filter-popup__header'>
			
										<button className='filter-popup__close'>
											<img src={closeIcon} alt='close' onClick={() => setShowPopup(false)} ></img>
										</button>
									</div>
									<div className='cargo-portal-container filter-popup__content'>
									   <span className='filter-heading'>{t('COMMON.SORT_BY')}</span>
										<div className='filter-popup__item form-item--radio'>
											{/* <input
												type='radio'
												id='tempCheepest'
												className='form-item__field m-0'
												checked={tempCheepest}
												onChange={() => {
													setTempCheepest(!tempCheepest);
													setTempFastest(false);
													setTempLeastStops(false);
												}}
											/>
											<label className='form-item__label' htmlFor='tempCheepest'>{t('COMMON.CHEAPEST')}</label> */}
											<CommonRadioWithLabel
												id="tempCheepest"
												name="flightOptions"
												value="cheapest"
												checked={tempCheepest}
												onChange={() => {
													setTempCheepest(!tempCheepest);
													setTempFastest(false);
													setTempLeastStops(false);
												}}
												label={t('COMMON.CHEAPEST')}
											/>

										</div>
										<div className='filter-popup__item form-item--radio'>
											{/* <input
												type='radio'
												id='tempFastest'
												className='form-item__field m-0'
												checked={tempFastest}
												onChange={() => {
													setTempFastest(!tempFastest);
													setTempCheepest(false);
													setTempLeastStops(false);
												}}
											/>
											<label className='form-item__label' htmlFor='tempFastest'>{t('CHOOSE_FLT.FASTEST')}</label> */}
											<CommonRadioWithLabel
												id="tempFastest"
												name="flightOptions"
												value="fastest"
												checked={tempFastest}
												onChange={() => {
													setTempFastest(!tempFastest);
													setTempCheepest(false);
													setTempLeastStops(false);
												}}
												label={t('CHOOSE_FLT.FASTEST')}
											/>

										</div>
										<div className='filter-popup__item form-item--radio'>
											{/* <input
												type='radio'
												id='tempLeastStops'
												className='form-item__field m-0'
												checked={tempLeastStops}
												onChange={() => {
													setTempLeastStops(!tempLeastStops);
													setTempCheepest(false);
													setTempFastest(false);
												}}
											/>
											<label className='form-item__label' htmlFor='tempLeastStops'>{t('CHOOSE_FLT.LEAST_STOPS')}</label> */}
											<CommonRadioWithLabel
												id="tempLeastStops"
												name="flightOptions"
												value="leastStops"
												checked={tempLeastStops}
												onChange={() => {
													setTempLeastStops(!tempLeastStops);
													setTempCheepest(false);
													setTempFastest(false);
												}}
												label={t('CHOOSE_FLT.LEAST_STOPS')}
											/>

										</div>
									</div>
									<div className='filter-popup__footer'>
										<button
											className='filter__applybtn'
											onClick={() => {
												setShowPopup(false); // Close the popup
												setcheepest(tempCheepest);
												setfastest(tempFastest);
												setleastStops(tempLeastStops);
												setFilter(
													tempCheepest ? 'cheepest' : tempFastest ? 'fastest' : 'leastStops'
												); // Apply the selected filter
											}}
										>
											{t('COMMON.APPLY')} 
										</button>
									</div>
								</div>
								</div>
							)}
						</li> 
					</ul>
				</div>
				{/* <div className='flight-details__allotment-wrapper m-0 d-none d-lg-flex'> */}
					{/* {
					(isUSBound) ? (
						<>
							<div className='l-checkbox'>
								<input
									id={`unknown-shipemnt`}
									type='checkbox'
									checked={isUnknownShipment}
									onChange={(e) => {
										handleUnknownShimentFilter(!isUnknownShipment)
									}}
								/>
								<label className='mb-3' htmlFor={`unknown-shipemnt`}></label>
							</div>
							<span className='flight-details__allotment-description'>
								{t('BOOKING.FILTER_PSNGR_US_OUTBOUND')}
							</span>
						</>
					 ) : (<></>)
				}				 */}

					{/* <div className='l-checkbox'>
						<input
							id={`allotment`}
							type='checkbox'
							checked={isAllotmentsOnly}
							onChange={(e) => {
								setAllotmentsOnly(!isAllotmentsOnly)
								handleAllotmentFilter(!isAllotmentsOnly, e)
							}}
						/>
						<label className='mb-3' htmlFor={`allotment`}></label>
					</div>
					<span className='flight-details__allotment-description'>
						{t('CHOOSE_FLT.FLIGHTS_ALLOTMENT')}
					</span>
					<div className='flight-details__allotment-indicator' />
				</div> */}
			</div>
		</div>
	)
}

export default FilterOptions